import styled from 'styled-components'

export const Header = styled.header`
  align-items: center;
  background-color: #fdfdff;
  border-bottom: 2px solid #f7f7f7;
  display: flex;
  height: 80px;
  justify-content: space-between;
  padding: 0 80px 0 20px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: var(--z-index-header);
`

export const Logo = styled.div`
  align-items: center;
  display: flex;

  > img {
    cursor: pointer;
    height: 30px;
  }
`

export const UserContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`

export const UserImage = styled.div`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  margin-right: 10px;
  width: 40px;
`
